import React from 'react';
export function TestimonialsToWhatToExpectDivider() {
  return <div className="relative w-full overflow-hidden" style={{
    backgroundColor: '#2d4a3a'
  }} data-id="element-507">
      

      <style data-id="element-508">{`
        @keyframes testimonialsToWhatWave {
          0%, 100% {
            transform: translateX(0) scaleY(1);
          }
          50% {
            transform: translateX(-25px) scaleY(1.05);
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          svg path {
            animation: none !important;
          }
        }
      `}</style>
    </div>;
}